const pasos = {
  namespaced: true,
  state: {
    pasos: {
      es: {
        1: {
          id: 1,
          title: "Profesión de Fe y disposición",
          filter: "dia",
          subtitle: "",
          help:
            "Iniciamos nuestra oración con el Credo y colocamos este nuevo día en las manos del Padre:",
          prays: [
            {
              id: "1.1",
              title: "Credo de los Apóstoles",
              pray:
                "<p>Creo en Dios, Padre Todopoderoso, Creador del cielo y de la tierra.</p><p>Creo en Jesucristo su único Hijo Nuestro Señor, que fue concebido por obra y gracia del Espíritu Santo.</p><p>Nació de Santa María Virgen, padeció bajo el poder de Poncio Pilato, fue crucificado, muerto y sepultado, descendió a los infiernos, al tercer día resucitó de entre los muertos, subió a los cielos y está sentado a la derecha de Dios Padre, todopoderoso.</p><p>Desde allí ha de venir a juzgar a vivos y muertos.</p><p>Creo en el Espíritu Santo, la Santa Iglesia católica, la comunión de los santos, el perdón de los pecados, la resurrección de la carne y la vida eterna.<br><strong>Amén.</strong></p>",
              credit: ""
            },
            {
              id: "1.2",
              title: "Oración al Padre",
              pray:
                "<p>Padre: en tus manos me pongo, haz de mí lo que Tú quieras, y por todo lo que hagas de mí yo te doy gracias.</p><p>Estoy dispuesto a todo, y lo acepto todo con tal que Tu Voluntad se cumpla en mí y en todas tus creaturas.</p><p>No deseo nada más, Dios mío, pongo mi alma entre tus manos, te la doy con todo el ardor de mi corazón porque es una necesidad de amor, el darme, el entregarme entre tus manos sin medida, con infinita confianza porque Tú eres mi Padre.<br><strong>Amén.</strong></p>",
              credit: "Beato Charles de Foucauld"
            }
          ]
        },
        2: {
          id: 2,
          title: "Invocar el Espíritu Santo",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "2.1",
              title: "",
              pray:
                "<p>Ven Espíritu Divino, manda tu luz desde el cielo, Padre amoroso del pobre; don, en tus dones espléndido; luz que penetras las almas; fuente del mayor consuelo.</p><p>Ven dulce huésped del alma, descanso en nuestros esfuerzos, tregua en el duro trabajo, brisa en las horas de fuego, gozo que enjuga las lágrimas, y reconforta en los duelos.</p><p>Llega hasta el fondo del alma Divina Luz y enriquécenos. Mira el vacío del hombre si Tú le faltas por dentro. Mira el poder del pecado cuando no envías tu aliento.</p><p>Riega la tierra en sequía, sana el corazón enfermo, lava las manchas. Infunde calor de vida en el hielo. Doma el espíritu indómito, guía al que tuerce el sendero.</p><p>Reparte tus siete dones según la fe de tus siervos. Por tu bondad y tu gracia dale al esfuerzo su mérito. Salva al que busca salvarse y danos tu gozo eterno.<br><strong>Amén.</strong></p></p>",
              credit: ""
            }
          ]
        },
        3: {
          id: 3,
          title: "Oración de Arrepentimiento",
          filter: "dia",
          subtitle: "",
          help:
            "Todos somos pecadores. Examina en qué has fallado, en tu relación con Dios, con tu familia, comunidad, con los demás y contigo mismo. Aflora y coloca a los pies de la cruz de Cristo todo lo que te pueda distraer.",
          prays: [
            {
              id: "3.1",
              title: "Oración",
              pray:
                "<p>Jesús, mi Señor y Redentor: yo me arrepiento de todos los pecados que he cometido hasta hoy, y me pesa de todo corazón, porque con ellos he ofendido a un Dios tan bueno. Propongo firmemente no volver a pecar y confío en que, por tu infinita misericordia, me has de conceder el perdón de mis culpas y me has de llevar a la vida eterna.<br><strong>Amén.</strong></p>",
              credit: ""
            },
            {
              id: "3.2",
              title:
                "Oración de Santa Faustina<br>para confiar en la Misericordia:",
              pray:
                '<p>Oh Sangre y Agua que brotaste del Corazón de Jesús, como una fuente de Misericordia para nosotros, en Ti confío.<br><span class="grey--text">(3 veces)</span></p>',
              credit: "Diario de Santa Faustina (No. 84)"
            }
          ]
        },
        4: {
          id: 4,
          title: "Oración para el encuentro con la Palabra",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "4.1",
              title: "",
              pray:
                "<p>Te doy gracias Señor, porque Tu Palabra sigue siendo viva y eficaz entre nosotros. Reconozco mi impotencia e incapacidad para comprenderla y dejarla vivir en mi ser y en mis relaciones con los que me rodean. Tu Palabra es más poderosa y más fuerte que mis debilidades, más eficaz que mi fragilidad, más penetrante que mis resistencias. Por esto te pido que me ilumines, para que la tome en serio y me abra a aquello que me manifiesta, para que confíe en ella, y le permita actuar en mí de acuerdo con la riqueza de su poder.</p><p>Madre de Jesús, que confiaste sin reservas, pidiendo que se cumpliera en ti la Palabra que te fue dirigida, dame el espíritu de disponibilidad para que a la luz de la Palabra encuentre la verdad sobre mi vida y pueda ayudar a los demás a encontrar la verdad de Dios sobre toda creación.</p><p>Te lo pido, Padre, por Jesucristo, tu Palabra encarnada, por su muerte y resurrección, y por el Espíritu Santo que renueva constantemente en nosotros la fuerza de esta Palabra que me dispongo a escuchar con actitud de discípulo tuyo.<br><strong>Amén.</strong></p>",
              credit: "Cardenal Carlo Martini"
            }
          ]
        },
        5: {
          id: 5,
          title: "Lee y Medita",
          filter: "dia",
          subtitle: "Lectio Divina",
          help: [
            "<p><strong>¿Qué dice el texto?</strong><br>Lo primero que hacemos es leer los textos bíblicos y subrayar aquellos que me llaman la atención.</p>",
            '<p>Después de elegir los textos reflexiona con esta pregunta: ¿Señor con esta Palabra qué le quieres decir a mis problemas y mis pecados? Y responde con una oración en primera persona que puede comenzar así: "Amado Padre, en esta mañana escucho tu Palabra que me dice..." y concluye con un compromiso el cual debes realizar durante el día a partir de lo que te ha dicho la Palabra.</p>',
            "<p>Enriquece tu oración, con una pequeña reflexión y oración fundamentada en la enseñanza de la Iglesia y la espiritualidad de la Divina Misericordia.</p>"
          ],
          prays: []
        },
        6: {
          id: 6,
          title: "Oración para ser Misericordioso",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "6.1",
              title: "",
              pray:
                "<p>Cuantas veces respira mi pecho, cuantas veces late mi corazón, cuantas veces pulsa la sangre en mi cuerpo, esa cantidad por mil, es el número de veces que deseo glorificar tu misericordia, oh Santísima Trinidad.</p>" +
                "<p>Deseo transformarme toda en Tu Misericordia y ser un vivo reflejo de Ti, oh Señor. Que este más grande atributo de Dios, es decir Su insondable misericordia, pase a través de mi corazón al prójimo.</p>" +
                "<p>Ayúdame oh Señor, a que mis ojos sean misericordiosos, para que yo jamás, recele o juzgue según las apariencias, sino que busque lo bello en el alma de mi prójimo y acuda a ayudarla.</p>" +
                "<p>Ayúdame a que mis oídos sean misericordiosos para que tome en cuenta las necesidades de mi prójimo y no sea indiferente a sus penas y gemidos.</p>" +
                "<p>Ayúdame oh Señor, a que mi lengua sea misericordiosa para que jamás hable negativamente de mi prójimo sino que tenga unas palabras de consuelo y perdón para todos.</p>" +
                "<p>Ayúdame oh Señor, a que mis manos sean misericordiosas y llenas de buenas obras para que sepa hacer solo el bien a mi prójimo y cargue sobre mí las tareas más difíciles y más penosas.</p>" +
                "<p>Ayúdame a que mis pies sean misericordiosos para que siempre me apresure a socorrer a mi prójimo, dominando mi propia fatiga y mi cansancio. Mi reposo verdadero está en el servicio a mi prójimo.</p>" +
                "<p>Ayúdame, oh Señor, a que mi corazón sea misericordioso para que yo sienta todos los sufrimientos de mi prójimo. A nadie le rehusaré mi corazón. Seré sincera incluso con aquellos de los cuales sé que abusarán de mi bondad. Y yo misma me encerraré en el Misericordioso Corazón de Jesús. Soportaré mis propios sufrimientos en silencio. Que Tu misericordia, oh Señor mío, repose dentro de mí.</p>" +
                '<p><strong><span class="primary--text">Oh Jesús mío transfórmame en Ti, porque Tú puedes hacer todo.</span><br>Amén.</strong></p>',
              credit: "Diario de Santa Faustina No. 163"
            }
          ]
        },
        7: {
          id: 7,
          title: "Acción de gracias y protección",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "7.1",
              title: "",
              pray:
                "<p>Gracias Padre por este nuevo día y por el don de tu Palabra, en unión con el Espíritu Santo pido que el poder de la Sangre preciosa de Jesús me cubra, selle, guarde, proteja, sane, libere y me dé vida en abundancia en todo mi ser integral, en mi familia, mi historia, mis bienes, las personas que dispones a mi lado, Tu Voluntad sobre mi vida, mis funciones vitales y sociales, los lugares que vivo y visito, mi espacio y la creación entera. Tu preciosa Sangre me libre de las tentaciones y de todo mal ahora y en la hora de mi muerte.<br><strong>Amén.</strong></p>",
              credit: ""
            }
          ]
        },
        8: {
          id: 8,
          title: "Oración para la noche",
          filter: "noche",
          subtitle: "",
          help:
            "Con este espacio de oración diaria también en la noche, Misericordia Día a Día desea que la Palabra que vivimos en el trascurso del día sea motivo de oración al finalizar la jornada. Junto con algunas oraciones de las Completas en la Liturgia de la Horas, nos unimos a la Iglesia Universal para ofrecer el día al Señor",
          prays: [
            {
              id: "8.0",
              title: "Invocación",
              pray:
                '<p><span class="primary--text">V/.</span> Dios mío ven en mi auxilio.<br><span class="primary--text">R/.</span> Señor date prisa en socorrerme.</p>',
              credit: ""
            },
            {
              id: "8.1",
              title: "Himno",
              pray:
                "<p>Cuando la luz del sol es ya poniente, gracias, Señor, es nuestra melodía; recibe, como ofrenda, amablemente, nuestro dolor, trabajo y alegría.</p>" +
                "<p>Si poco fue el amor en nuestro empeño de darle vida al día que fenece, convierte en realidad lo que fue un sueño tu gran amor que todo lo engrandece.</p>" +
                "<p>Tu cruz, Señor, redime nuestra suerte de pecadora en justa, e ilumina la senda de la vida y de la muerte del hombre que en la fe lucha y camina.</p>" +
                "<p>Jesús, Hijo del Padre, cuando avanza la noche oscura sobre nuestro día, concédenos la paz y la esperanza de esperar cada noche tu gran día. <strong>Amén.</strong></p>",
              credit: ""
            },
            {
              id: "8.2",
              title: "Examen de Conciencia",
              pray:
                "<p>Para hacerlo es necesario tener en cuenta la Palabra del día, las metas que nos pusimos, si fue posible cumplirlas o no. Esta oración consiste en agradecer a Dios por lo que la Palabra hizo durante el día y en reconocer fragilidad delante de Él y pedirle perdón.</p>" +
                '<p><span class="primary--text">V/.</span> Señor, ten misericordia de nosotros.<br>' +
                '<span class="primary--text">R/.</span> Porque hemos pecado contra ti.<br>' +
                '<span class="primary--text">V/.</span> Muéstranos, Señor tu misericordia.<br>' +
                '<span class="primary--text">R/.</span> Y danos tu salvación.</p>',
              credit: ""
            },
            {
              id: "8.3",
              title:
                'Cántico de Simeón <span class="grey--text"> | Lc 2,29-32</span>',
              pray:
                "<p>Ahora, Señor, según Tu promesa, puedes dejar a tu siervo irse en paz, porque mis ojos han visto a Tu Salvador, a quien has presentado ante todos los pueblos, luz para alumbrar a las naciones y gloria de Tu pueblo Israel.</p>" +
                "<p>Gloria al Padre, al Hijo<br>y al Espíritu Santo...</p>",
              credit: ""
            },
            {
              id: "8.4",
              title: "Oración a la Virgen María",
              pray:
                "<p>Bajo tu protección nos acogemos, Santa Madre de Dios; no deseches las súplicas que te dirigimos en nuestras necesidades; antes bien, líbranos de todo peligro, oh Virgen gloriosa y bendita.</p>",
              credit: ""
            }
          ]
        }
      },
      pt: {
        1: {
          id: 1,
          title: "Profissão de fé e disposição",
          filter: "dia",
          subtitle: "",
          help:
            "Iniciemos nossa oração com o Credo e reconhecendo, neste novo dia, que nossa identidade é de filhos do Pai Misericordioso:",
          prays: [
            {
              id: "1.1",
              title: "Credo dos Apóstolos",
              pray:
                "<p>Creio em Deus, Pai todo-poderoso, criador do céu e da terra. E em Jesus Cristo, seu único Filho, nosso Senhor, que foi concebido pelo poder do Espírito Santo.</p>" +
                "<p>Nasceu da Virgem Maria; padeceu sob Pôncio Pilatos, foi crucificado, morto e sepultado. Desceu à mansão dos mortos; ressuscitou ao terceiro dia, subiu aos céus; está sentado à direita de Deus Pai todo-poderoso, donde há de vir a julgar os vivos e os mortos.</p>" +
                "<p>Creio no Espírito Santo; na Santa Igreja Católica; na comunhão dos santos; na remissão dos pecados; na ressurreição da carne; na vida eterna." +
                "<br><strong>Amém.</strong></p>",
              credit: ""
            },
            {
              id: "1.2",
              title: "Oração de abandono ao Pai",
              pray:
                "<p>Meu Pai, eu me abandono a Ti, faz de mim o que quiseres. O que fizeres de mim, eu Te agradeço.</p>" +
                "<p>Estou pronto para tudo, aceito tudo. Desde que a Tua vontade se faça em mim, e em tudo o que Tu criastes, nada mais quero, meu Deus.</p>" +
                "<p>Nas Tuas mãos entrego a minha vida. Eu Te a dou, meu Deus, com todo o amor do meu coração, porque Te amo e é para mim uma necessidade de amor dar-me, entregar-me nas Tuas mãos sem medida, com uma confiança infinita porque Tu és... Meu Pai!" +
                "<br><strong>Amém.</strong></p>",
              credit: "Beato Charles de Foucauld"
            }
          ]
        },
        2: {
          id: 2,
          title: "Invocação ao Espírito Santo",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "2.1",
              title: "",
              pray:
                "<p>Espírito de Deus, enviai dos céus um raio de luz!</p>" +
                "<p>Vinde, Pai dos pobres, dai aos corações vossos sete dons.</p>" +
                "<p>Consolo que acalma, hóspede de alma, doce alívio, vinde!</p>" +
                "<p>No labor descanso, na aflição remanso no calor, aragem.</p>" +
                "<p>Enchei, luz bendita, chama que crepita, o íntimo de nós!</p>" +
                "<p>Sem a luz que acode, nada o homem pode nenhum bem há nele.</p>" +
                "<p>Ao sujo lavai, ao seco regai, curai o doente.</p>" +
                "<p>Dobrai  que é duro, guiai no escuro o frio aquecei.</p>" +
                "<p>Dai à vossa Igreja, que espera e deseja, vossos sete dons.</p>" +
                "<p>Dai em prêmio ao forte uma santa morte alegria eterna." +
                "<br><strong>Amém.</strong></p>",
              credit: ""
            }
          ]
        },
        3: {
          id: 3,
          title: "Oração de Perdão",
          filter: "dia",
          subtitle: "",
          help:
            "Todos somos pecadores. Examine o que tens falado, tua relação com Deus, com tua família, comunidade e consigo mesmo. Coloque todos os seus problemas e distrações aos pés de Cristo.",
          prays: [
            {
              id: "3.1",
              title: "Oração",
              pray:
                "<p>Jesus, meu Senhor e Redentor: eu me arrependo de todos os pecados que tenho cometido até hoje e pesam em meu coração, porque com eles tenho ofendido a um Deus tão bom. Proponho-me firmemente não voltar a pecar e confio que, por sua infinita misericórdia, o Senhor me concede o perdão de minhas culpas e me sustenta por sua graça até a vida eterna.<br><strong>Amém.</strong></p>",
              credit: ""
            },
            {
              id: "3.2",
              title:
                "Oração de Santa Faustina para confiar em Sua Misericórdia",
              pray:
                '<p>Ó Sangue e Água, que jorrastes do Coração de Jesus como fonte de misericórdia para nós, eu confio em Vós!<span class="grey--text"> (3 vezes)</span></p>',
              credit: "Diário de Santa Faustina (No. 84)"
            }
          ]
        },
        4: {
          id: 4,
          title: "Oração para o encontro com a Palavra",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "4.1",
              title: "",
              pray:
                "<p>Eu te agradeço Senhor porque Sua Palavra é viva e eficaz entre nós. Reconheço minha impotência e incapacidade para compreendê-la e deixá-la criar vida em meu ser e em minhas relações. Sua Palavra é mais poderosa e mais forte que minhas fraquezas, mais eficaz que minha fragilidade, mais penetrante que minhas resistências. Por isso peço que me ilumine, para que eu tome posse da sua Palavra e me abra àquilo que ela me revela, para que eu confie nela, e lhe permita agir em mim de acordo com a riqueza de seu poder.</p>" +
                "<p>Maria, Mãe de Jesus, que confiou sem reservas, pedindo que se cumprisse em Ti a Palavra que lhe foi proclamada pelo Anjo Gabriel, ensina-me a ter um espírito de disponibilidade para que à Luz da Palavra eu também encontre a verdade sobre minha vida e possa ajudar aos demais a encontrar a verdade de Deus sobre toda a criação.</p>" +
                "<p>Pai, eu te peço, por Jesus Cristo, Sua Palavra encarnada, por sua morte e ressurreição, e pelo Espírito Santo que renova constantemente em nós a força desta Palavra, que faça com que meu coração esteja disposto a escutar com atitude de discípulo seu." +
                "<br><strong>Amém.</strong></p>",
              credit: "Cardeal Carlo Martini"
            }
          ]
        },
        5: {
          id: 5,
          title: "Leia, medite e ore",
          filter: "dia",
          subtitle: "Lectio Divina",
          help: [
            "<p><strong>O que diz o texto?</strong><br>A primeira coisa a se fazer é ler os textos bíblicos e sublinhar tudo aquilo que te chamar a atenção.</p>",
            '<p>Depois de selecionar os textos, refletir com essa pergunta: Senhor, com esta Palavra o que queres dizer a meus problemas, meus pecados? E responde com uma oração em primeira pessoa; que pode começar assim: "Amado Pai, nesta manhã, escuto tua Palavra que me diz... " "e conclue com um compromisso no qual deves realizar durante o dia, a partir do que te disse a Palavra.</p>',
            "<p>Enriqueça sua oração com uma pequena reflexão e oração fundamentada nos ensinamentos da Igreja e na espiritualidade da Divina Misericórdia.</p>"
          ],
          prays: []
        },
        6: {
          id: 6,
          title: "Oração para ser Misericordioso",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "6.1",
              title: "",
              pray:
                "<p>Ó Santíssima Trindade, quantas vezes o meu peito respirar, quantas vezes o meu coração bater, quantas vezes o meu sangue pulsar em mim, outras tantas mil vezes desejo adorar a Vossa misericórdia.</p>" +
                "<p>Desejo transformar-me toda em Vossa Misericórdia, para tornar-me o Vosso reflexo vivo, ó meu Senhor!</p>" +
                "<p>Que a Vossa Misericórdia, que é insondável e de todos os atributos de Deus o mais sublime, se derrame através do meu coração e da minha alma sobre o próximo.</p>" +
                "<p>Ajudai-me, Senhor, para que os meus olhos sejam misericordiosos, de modo que eu jamais suspeite nem julgue as pessoas pela aparência externa, mas perceba a beleza interior dos outros e possa ajudá-los.</p>" +
                "<p>Ajudai-me, Senhor, para que os meus ouvidos sejam misericordiosos, de modo que eu esteja atenta às necessidades dos meus irmãos e não me permitais permanecer indiferente diante de suas dores e lágrimas.</p>" +
                "<p>Ajudai-me, Senhor, para que a minha língua seja misericordiosa, de modo que eu nunca fale mal dos meus irmãos; que eu tenha para cada um deles uma palavra de conforto e de perdão.</p>" +
                "<p>Ajudai-me, Senhor, para que as minhas mãos sejam misericordiosas e transbordantes de boas obras, nem se cansem jamais de fazer o bem aos outros, enquanto aceite para mim as tarefas mais difíceis e penosas.</p>" +
                "<p>Ajudai-me, Senhor, para que sejam misericordiosos também os meus pés, para que levem sem descanso ajuda aos meus irmãos, vencendo a fadiga e o cansaço; o meu repouso esteja no serviço ao próximo.</p>" +
                "<p>Ajuda-me Senhor, para que o meu coração seja misericordioso e se torne sensível a todos os sofrimentos do próximo; ninguém receba uma recusa do meu coração. Que eu conviva sinceramente, mesmo com aqueles que abusam da minha bondade. Quanto a mim, me encerro no Coração Misericordiosíssimo de Jesus, silenciando aos outros o quanto tenha que sofrer. A minha oração pode atingir até onde não posso estar fisicamente.</p>" +
                '<p><strong><span class="primary--text">Ó meu Jesus, transformai-me em Vós, porque Vós tudo podeis.</span></strong><br><strong>Amém.</strong></p>',
              credit: "Diário de Santa Faustina No. 163"
            }
          ]
        },
        7: {
          id: 7,
          title: "Ação de Graças e proteção",
          filter: "dia",
          subtitle: "",
          help: "",
          prays: [
            {
              id: "7.1",
              title: "",
              pray:
                "<p>Pai, te agradeço por este novo dia e pelo dom de Sua Palavra. Em união com o Espírito Santo, peço que o poder do sangue precioso de Jesus, me cubra, zele, guarde, proteja, cure, liberte e, me dê vida em abundância em todo meu ser, em minha família, minha história, meus bens, as pessoas com quem me relaciono, sua vontade sobre minha vida, minhas funções vitais e sociais, os lugares que vivo e visito, meu espaço e a criação inteira. Com seu precioso sangue livra-me das tentações e de todo mal agora e na hora de minha morte.<br><strong>Amém.</strong></p>",
              credit: ""
            }
          ]
        },
        8: {
          id: 8,
          title: "Oração para a noite",
          filter: "noche",
          subtitle: "",
          help:
            "Com este espaço de oração diária também na noite, Misericórdia Dia a Dia deseja que a Palavra que vivemos em decorrência do dia seja motivo de oração ao finalizar a jornada. Junto com algumas orações das Completas na Liturgia das Horas, unimo-nos à Igreja Universal para agradecer o dia que o Senhor nos deu e confiar nosso descanso a Ele.",
          prays: [
            {
              id: "8.0",
              title: "Invocação",
              pray:
                '<p><span class="primary--text">V/.</span> Vinde, ó Deus, em meu auxílio.<br><span class="primary--text">R/.</span> Socorrei-me sem demora.</p>' +
                "<p>Glória ao Pai e ao Filho e ao Espírito Santo. Como era no princípio, agora e sempre.</p>" +
                "<br><strong>Amém.</strong></p>",
              credit: ""
            },
            {
              id: "8.1",
              title: "Hino",
              pray:
                "<p>Agora que o clarão da luz se apaga, a vós nós imploramos, Criador: com vossa paternal misericórdia, guardai-nos sob a luz do vosso amor.</p>" +
                "<p>Os nossos corações sonhem convosco: no sono, possam eles vos sentir. Cantemos novamente a vossa glória ao brilho da manhã que vai surgir.</p>" +
                "<p>Saúde concedei-nos nesta vida, as nossas energias renovai; da noite a pavorosa escuridão com vossa claridade iluminai.</p>" +
                "<p>Ó Pai, prestai ouvido às nossas preces, ouvi-nos por Jesus, nosso Senhor, que reina para sempre em vossa glória, convosco e o Espírito de Amor.</p>",
              credit: ""
            },
            {
              id: "8.2",
              title: "Exame de Consciência",
              pray:
                "<p>Para o exame de consciência é necessário ter em conta a Palavra do dia, as metas que nos dispusemos a cumprir, se foi possível cumpri-las ou não. Esta oração consiste em agradecer a Deus pelo que a Palavra fez durante o dia e em reconhecer nossa fragilidade diante dele, e lhe pedir perdão.</p>" +
                '<p><span class="primary--text">V/.</span> Tende compaixão de nós.<br>' +
                '<span class="primary--text">R/.</span> Porque nós somos pecadores.<br>' +
                '<span class="primary--text">V/.</span> Mostre-nos, Senhor sua misericórdia.<br>' +
                '<span class="primary--text">R/.</span> E dá-nos a sua salvação.</p>',
              credit: ""
            },
            {
              id: "8.3",
              title:
                'Cântico de Simeão <span class="grey--text"> | Lc 2,29-32</span>',
              pray:
                "<p>Deixai, agora, vosso servo ir em paz, conforme prometestes, ó Senhor. Pois meus olhos viram vossa salvação que preparastes ante a face das nações: uma Luz que brilhará para os gentios e para a glória de Israel, o vosso povo.</p>" +
                "<p>Glória ao Pai, ao Filho...</p>",
              credit: ""
            },
            {
              id: "8.4",
              title: "Oração à Virgem Maria",
              pray:
                "<p>À vossa proteção recorremos, santa Mãe de Deus; não desprezeis as nossas súplicas em nossas necessidades, mas livrai-nos sempre de todos os perigos, ó Virgem gloriosa e bendita." +
                "<br><strong>Amém.</strong></p>",
              credit: ""
            }
          ]
        }
      }
    }
  },
  getters: {
    oracion(state, getters, rootState, rootGetters) {
      let userConfig = rootGetters["user/config"];
      return state.pasos[userConfig.mdd.lng];
    }
  }
};

export default pasos;
